import 'url-search-params-polyfill';

import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';


import { createQueryString, parseQueryParams } from '../../utils/queryStringUtils';
import { contractCenterRoute } from '../../config/navigation/routes';
import * as RFQColumns from './ColumnGrids/RFQColumns';
import * as QuotesColumns from './ColumnGrids/QuotesColumns';

import * as DibbsColumns from './ColumnGrids/DibbsColumns';
import {
  getContractCenterData,
  archiveQuote,
  archiveRFQ,
} from './graphql';
import createRFQ from '../../graphql/sendRFQ';
import Actions from './actions';
import history from '../../config/history';
import Subscription from '../../components/Subscription/Subscription';

export default function ContractCenterHOC(ContractCenter) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
      }).isRequired,
      location: PropTypes.object.isRequired,
    };

    static initialState = {
      activeMenu: 'rfq',
      activeTab: null,
      activeData: [],
      contractCenterData: null,
      columns: [],
      rfqHits: 0,
      quoteHits: 0,
      isTourOpen: false,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const { organizationId } = this.props.auth;

      const location = this.props.location;

      if (location.search) {
        console.log("search", location.search);
        const queryParams = parseQueryParams(location);
        const activeMenu = queryParams.activeMenu;
        const activeTab = queryParams.activeTab;
        this.setState({
          activeMenu,
          activeTab,
        });
        await this.getContractData(organizationId, activeMenu, activeTab);
      } else {
        await this.getContractData(organizationId);
      }
    }

    getContractData = async (organizationId, activeMenu = this.state.activeMenu, activeTab = this.state.activeTab) => {
      const data = await getContractCenterData(organizationId);
      console.log(" getContractData ", data);
      // add error handling
      let columnGroup = RFQColumns;
      let updatedMenu = activeMenu;
      let updatedTab = activeTab;

      if (!updatedMenu || updatedMenu === 'rfq') {
        updatedMenu = 'rfq';
        columnGroup = RFQColumns;
        if (!updatedTab) {
          updatedTab = 'drafts'
        }
      }
      if (updatedMenu === 'quotes') {
        columnGroup = QuotesColumns;
        if (!updatedTab) {
          updatedTab = 'requested'
        }
      }
      if (updatedMenu === 'dibbs') {
        columnGroup = DibbsColumns;
        if (!updatedTab) {
          updatedTab = 'created'
        }
      }
      const columns = this.getColumns(columnGroup, updatedTab);
      const rfqHits = data.rfq.hits;
      const quoteHits = data.quotes.hits;

      console.log(rfqHits, quoteHits);

      const activeData = data[updatedMenu][updatedTab];

      this.setState({
        contractCenterData: data,
        activeTab: updatedTab,
        activeMenu: updatedMenu,
        columns,
        activeData,
        rfqHits: rfqHits.hits,
        quoteHits: quoteHits.hits,
      });
    };

    _changeMenu = e => {
      let activeTab = this.state.activeTab;
      let columnGroup = RFQColumns;
      let key = 'rfq';
      if (e.key.includes('quotes')) {
        key = 'quotes';
        columnGroup = QuotesColumns;
      }
      if (e.key.includes('dibbs')) {
        key = 'dibbs';
        columnGroup = DibbsColumns;
      }
      console.log(key, activeTab);
      if (
        key === 'rfq' &&
        (activeTab === 'requested' || activeTab === 'created')
      ) {
        activeTab = 'drafts';
      } else if (
        key === 'quotes' &&
        (activeTab === 'drafts' || activeTab === 'created' || activeTab === 'rfr')
      ) {
        activeTab = 'requested';
      } else if (key === 'dibbs') {
        activeTab = 'created';
      }

      const activeData = this.state.contractCenterData[key][activeTab];

      const columns = this.getColumns(columnGroup, activeTab);

      this.setState({
        activeMenu: e.key,
        columns,
        activeData,
        activeTab
      });
      const url = `${contractCenterRoute}?${createQueryString({
        activeMenu: e.key,
        activeTab,
      })}`;
      history.push(url);
    };

    getColumns = (columnGroup, activeTab) => {
      console.log("CATH getColumns", columnGroup, activeTab);
      const columns = [...columnGroup[activeTab]];
      if (activeTab !== "archived") {
        columns.push({
          Header: '',
          accessor: 'action',
          width: 100,

          Cell: cellProps => (
            <Actions cellProps={cellProps} selectedAction={this.selectedAction} />
          ),
        });
      }
      return columns;
    }

    closeTour = () => {
      this.setState({ isTourOpen: false });
    };

    openTour = () => {
      this.setState({ isTourOpen: true });
    };

    _createRFQ = async () => {
      const id = this.props.auth.id;

      const res = await createRFQ(id);
      console.log("res of createRFQ", res)
      const { rfqId, status } = res;
      if (status !== 'success') {
        console.log('error handling');
      } else {
        history.push(`/contractcenter/rfq?rfq=${rfqId}`);
      }
    };

    archiveSelection = async (rfqId, quoteId = null) => {
      const { id, organizationId } = this.props.auth;
      if (quoteId) {
        // here
        await archiveQuote(id, rfqId, quoteId);
      } else {
        await archiveRFQ(id, rfqId);
      }

      this.getContractData(organizationId);
    };

    selectedAction = (action, cellProps) => {
      console.log(action, cellProps);
      const { rfqId, quoteId } = cellProps;
      switch (action) {
        case 'delete':
          this.archiveSelection(rfqId, quoteId);
          break;

        default:
          break;
      }
    };

    _changeTab = activeTab => {
      let columnGroup = RFQColumns;
      let key = 'rfq';

      if (this.state.activeMenu.includes('quotes')) {
        key = 'quotes';
        columnGroup = QuotesColumns;
      }
      if (this.state.activeMenu.includes('dibbs')) {
        key = 'dibbs';
        columnGroup = DibbsColumns;
      }

      const activeData = this.state.contractCenterData[key][activeTab];
      const columns = this.getColumns(columnGroup, activeTab);

      this.setState({
        activeTab,
        columns,
        activeData,
      });
      const url = `${contractCenterRoute}?${createQueryString({
        activeMenu: this.state.activeMenu,
        activeTab,
      })}`;
      history.push(url);
    };

    render() {
      const {
        activeMenu,
        activeTab,
        columns,
        activeData,
        rfqHits,
        quoteHits,
        isTourOpen,
      } = this.state;
      const pageProps = {
        isTourOpen,
        activeData,
        rfqHits,
        quoteHits,
        activeMenu,
        activeTab,
        columns,
        changeMenu: this._changeMenu,
        changeTab: this._changeTab,
        auth: this.props.auth,
        createRFQ: this._createRFQ,
        closeTour: this.closeTour,
        openTour: this.openTour,
      };
      return (
        <Subscription service="RFQ Management" level="ICON Plus">
          <ContractCenter {...pageProps} />
        </Subscription>
      );
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ContractCenterHOC.jsx